<template>
    <div class="fixed-buttons">
        <button @click="scrollToTop">回到<br />顶部</button>
        <button @click="refreshPage">数据<br />刷新</button>
    </div>
</template>
<!-- 使用方法:
    1. 引入组件
    2. 注册组件
    3. 调用组件,监听scroll-to-top,提醒父组件调用 回到顶部方法
    4. data.return scrollableDiv
    5. vue.mounted() {
		this.scrollableDiv = this.$refs.scrollableDiv;
		this.scrollableDiv.addEventListener('scroll', this.handleScroll);
	},
    6. vue.method.scrollToTop() {
			this.scrollableDiv.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}
-->
<script>
    export default {
        name: "FixedButtons",
        methods: {
            scrollToTop() {
                this.$emit("scroll-to-top");
            },
            refreshPage() {
                // 获取当前页面的 URL
                let currentUrl = window.location.href;
                // 移除 URL 中的查询参数部分
                let baseUrl = currentUrl.split("?")[0];
                // 使用新的 URL 替换当前页面
                window.location.replace(baseUrl);
                window.location.reload();
            },
        },
    };
</script>

<style scoped>
    .fixed-buttons {
        position: fixed;
        bottom: 20px;
        right: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        z-index: 1000;
    }

    .fixed-buttons button {
        padding: 12px 15px;
        background-color: #007bff;
        color: white;
        border: none;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        transition: background-color 0.3s ease, transform 0.2s ease;
    }

    .fixed-buttons button:hover {
        background-color: #0056b3;
        transform: translateY(-2px);
    }

    .fixed-buttons button:active {
        transform: translateY(0);
    }

    @media (max-width: 600px) {
        .fixed-buttons {
            bottom: 10px;
            right: 10px;
        }

        .fixed-buttons button {
            padding: 10px 20px;
        }
    }
</style>
